export default "<title>{{title}}</title>\n<router-outlet></router-outlet>";